import { useEffect, useMemo, useState } from "react";

export function formatRemainSeconds(seconds) {
  if (seconds == null || Number.isNaN(seconds)) return "--:--:--";
  if (seconds <= 0) return "00:00:00";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds / 60) % 60);
  const secs = Math.floor(seconds % 60);
  if (hours > 23) {
    const days = Math.floor(hours / 24);
    return `${days}d ${String(hours % 24).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

function remainFromNextAt(nextAt, nowMs) {
  if (!nextAt) return null;
  const t = new Date(nextAt).getTime();
  if (Number.isNaN(t)) return null;
  return Math.max(0, Math.floor((t - nowMs) / 1000));
}

/**
 * Live 1s countdown from API events that include `nextAt` (ISO).
 * Falls back to static `time` / `remainSeconds` when nextAt is missing.
 */
export function useLiveEventCountdowns(events) {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  return useMemo(() => {
    const list = Array.isArray(events) ? events : [];
    return list.map((ev) => {
      const live = remainFromNextAt(ev?.nextAt, nowMs);
      const remain =
        live != null
          ? live
          : typeof ev?.remainSeconds === "number"
            ? Math.max(0, ev.remainSeconds)
            : null;
      return {
        ...ev,
        remainSeconds: remain,
        time:
          remain != null
            ? formatRemainSeconds(remain)
            : ev?.time || "--:--:--",
      };
    });
  }, [events, nowMs]);
}
